import graphql from "babel-plugin-relay/macro";
import { useAtomValue } from "jotai";

import { useTrackEvent } from "@/utils/Analytics/Mixpanel/hooks/useTrackEvent";

import { useMutationWithError } from "../../../../../../utils/hooks/useMutationWithError";
import { bookingSummaryAnalyticsDataAtom } from "../atoms/analytics/bookingSummaryAnalyticsDataAtom";
import { UpdateMemberNotesForBookingInput } from "./__generated__/useUpdateMemberNotesForBookingMutation.graphql";

export const useUpdateMemberNotesForBooking = () => {
  const [updateNotes, isUpdating] = useMutationWithError(
    useUpdateMemberNotesForBookingMutationString
  );

  const analyticsData = useAtomValue(bookingSummaryAnalyticsDataAtom);
  const trackEvent = useTrackEvent();

  const handleUpdateNotes = (
    input: UpdateMemberNotesForBookingInput,
    successCallback?: () => void
  ) =>
    updateNotes({
      variables: { input },
      onCompleted: () => {
        trackEvent("BookingDetail.MemberNotesUpdated", analyticsData ?? {});
        if (successCallback) {
          successCallback?.();
        }
      },
    });

  return [handleUpdateNotes, isUpdating] as const;
};

const useUpdateMemberNotesForBookingMutationString = graphql`
  mutation useUpdateMemberNotesForBookingMutation(
    $input: UpdateMemberNotesForBookingInput!
  ) {
    responsePayload: updateMemberNotesForBooking(input: $input) {
      booking {
        id
        notesFromMember
      }
      success
      errors {
        field
        code
        message
      }
    }
  }
`;
